import { CSSProperties, useId } from 'react'
import { CheckboxContainer } from './CheckboxContainer'
import { StyledCheckbox } from './StyledCheckbox'
import styled, { css } from 'styled-components'

export type CheckboxProps = {
  labelText: string
  defaultValue?: boolean
  containerStyle?: CSSProperties
  value?: boolean
  onClick?: () => void
  disabled?: boolean
}

const Label = styled.label<{ $clickable?: boolean }>`
  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
    `}
`

export const Checkbox = ({
  labelText,
  containerStyle,
  value = false,
  onClick,
  disabled = false
}: CheckboxProps) => {
  const inputId = useId()

  const handleToggle = () => {
    if (disabled) return
    if (onClick) onClick()
  }

  return (
    <CheckboxContainer style={containerStyle} $clickable={!!onClick && !disabled}>
      <StyledCheckbox
        id={inputId}
        type="checkbox"
        checked={value}
        onChange={handleToggle}
        errorPresent={false}
        disabled={disabled}
      />
      <Label htmlFor={inputId} $clickable={!!onClick && !disabled}>
        {labelText}
      </Label>
    </CheckboxContainer>
  )
}
